export function countCrossTopics(values: string[]): Map<string, number> {
  const map = new Map<string, number>();
  for (const raw of values) {
    const topic = (raw ?? '').trim();
    if (!topic) continue;
    map.set(topic, (map.get(topic) ?? 0) + 1);
  }
  return map;
}

export function sortCrossTopicKeys(keys: Iterable<string>): string[] {
  return Array.from(keys).sort((a, b) => a.localeCompare(b, 'ko', { numeric: true, sensitivity: 'base' }));
}

export type AlignedCrossTopicRow = {
  topic: string;
  term1: number | null;
  term2: number | null;
  annual: number;
};

export function alignCrossTopicCounts(
  term1: Map<string, number>,
  term2: Map<string, number>
): AlignedCrossTopicRow[] {
  const all = sortCrossTopicKeys(new Set([...Array.from(term1.keys()), ...Array.from(term2.keys())]));
  return all.map((topic) => {
    const t1 = term1.get(topic) ?? null;
    const t2 = term2.get(topic) ?? null;
    return { topic, term1: t1, term2: t2, annual: (t1 ?? 0) + (t2 ?? 0) };
  });
}
